import React, { useState } from "react";
import { MODAL_TYPES } from "../../utils/emitter";
import BaseModal from "../../components/BaseModal";
import "./style.scss";
import ROUTES from "../../utils/routes";
import BaseButton from "../../components/BaseButton";
import { useNavigate } from "react-router-dom";
import useModalActions from "../../hooks/useModalActions";
import { useTranslation } from "react-i18next";
import useChangeGender from "../../hooks/useChangeGender";
import useJoinGame from "../../hooks/useJoinGame";

export default function GenderNotification() {
  const { t } = useTranslation();
  const [payload, setPayload] = useState(null);
  const navigate = useNavigate();
  const { closeModal, openModal } = useModalActions();
  const { change } = useChangeGender();
  const { joinGame, isLoading } = useJoinGame();

  const handleClose = () => {
    navigate(ROUTES.PERSONAL_ACCOUNT_PAGE);
  };

  const handleChange = async () => {
    try {
      if (payload.link) {
        await change();
        await joinGame(payload.link);
        closeModal(MODAL_TYPES.GENDER_NOTIFICATION);
      }
    } catch(err) {
      console.error(err);
    }
  };
  return (
    <BaseModal
      onPayload={(e) => setPayload(e)}
      className="gender-modal"
      description={payload && payload.message ? payload.message : ""}
      titleStyle="gender-modal__title"
      eventTypeModal={MODAL_TYPES.GENDER_NOTIFICATION}
      contentStyle="gender-modal__actions"
      onClose={
        payload && payload.type && payload.type === "auth" ? handleClose : null
      }
    >
      {payload && payload.type && payload.type === "auth" && (
        <BaseButton
          typeSpinner="light"
          loading={isLoading}
          onClick={handleChange}
        >
          {t("genderModal.changeGenderButton")}
        </BaseButton>
      )}
    </BaseModal>
  );
}
